
































































































































































































































































































import Vue from "vue";
import Header from "@/components/Header.vue";

const PROTEINAS_POR_KG: Record<string, number> = {
  "Perder peso": 2.2,
  "Mantener peso": 1.8,
  "Ganar peso": 2.0,
};

const GRASAS_PCT: Record<string, number> = {
  "Perder peso": 0.25,
  "Mantener peso": 0.3,
  "Ganar peso": 0.25,
};

interface ResultadoMacros {
  proteinasG: number;
  proteinasKcal: number;
  proteinasPct: number;
  grasasG: number;
  grasasKcal: number;
  grasasPct: number;
  carbosG: number;
  carbosKcal: number;
  carbosPct: number;
  totalKcal: number;
  mensaje: string;
}

export default Vue.extend({
  name: "Macros-Diarios",
  components: { Header },
  data() {
    return {
      Meta: null as string | null,
      Peso: null as number | null,
      CaloriasTarget: null as number | null,
      resultado: null as ResultadoMacros | null,
      error: "" as string,
      mostrarRecursos: false,
    };
  },
  computed: {
    metaOpts(): Array<{ text: string; value: string | null }> {
      return [
        { text: String(this.$t("common.seleccionar")), value: null },
        { text: String(this.$t("macros.perder")), value: "Perder peso" },
        { text: String(this.$t("macros.mantener")), value: "Mantener peso" },
        { text: String(this.$t("macros.ganar")), value: "Ganar peso" },
      ];
    },
  },
  created() {
    const p = this.$store.state.profile;
    if (p.peso) this.Peso = p.peso;
    if (p.tdee) this.CaloriasTarget = p.tdee;
  },
  methods: {
    calcular() {
      this.error = "";
      this.resultado = null;

      if (!this.Meta) {
        this.error = this.$t("macros.error_meta") as string;
        return;
      }
      if (!this.Peso || !this.CaloriasTarget) {
        this.error = this.$t("macros.error_campos") as string;
        return;
      }
      if (this.CaloriasTarget < 500) {
        this.error = this.$t("macros.error_calorias") as string;
        return;
      }

      const proteinasPorKg = PROTEINAS_POR_KG[this.Meta];
      const grasasPct = GRASAS_PCT[this.Meta];

      const proteinasG = Math.round(this.Peso * proteinasPorKg);
      const proteinasKcal = proteinasG * 4;

      const grasasKcal = Math.round(this.CaloriasTarget * grasasPct);
      const grasasG = Math.round(grasasKcal / 9);

      const carbosKcal = Math.max(
        0,
        this.CaloriasTarget - proteinasKcal - grasasKcal
      );
      const carbosG = Math.round(carbosKcal / 4);

      const totalKcal = proteinasKcal + grasasKcal + carbosKcal;

      const proteinasPct = Math.round((proteinasKcal / totalKcal) * 100);
      const grasasPctReal = Math.round((grasasKcal / totalKcal) * 100);
      const carbosPct = 100 - proteinasPct - grasasPctReal;

      const mensajes: Record<string, string> = {
        "Perder peso": this.$t("macros.msg_perder") as string,
        "Mantener peso": this.$t("macros.msg_mantener") as string,
        "Ganar peso": this.$t("macros.msg_ganar") as string,
      };

      this.resultado = {
        proteinasG,
        proteinasKcal,
        proteinasPct,
        grasasG,
        grasasKcal,
        grasasPct: grasasPctReal,
        carbosG,
        carbosKcal,
        carbosPct,
        totalKcal,
        mensaje: mensajes[this.Meta],
      };
    },
  },
});
